import {FroalaEditor} from '@crema/modules/thirdParty';
export default FroalaEditor;
